export const styles = {
  container: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    width: '100%',
    marginBottom: 18,
    borderBottom: '1px solid #AEAFC7',
  },
  tab: {
    padding: '4px 20px 12px 20px',
    fontSize: 16,
    fontFamily: "'Proxima Nova Alt', sans-serif",
    fontWeight: '700',
    '&:hover': {
      opacity: 0.8,
    },
    cursor: 'pointer',
  },
}
